var _path, _line, _line2, _line3, _line4, _path2, _path3, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesIllustrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8496 9.86084L57.8666 11.2671C55.6048 14.503 51.9054 16.4307 47.9574 16.4307V16.4307C43.821 16.4307 39.9716 14.316 37.7532 10.8248L37.1406 9.86084",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55.3131,
    y1: 13.506,
    x2: 57.5982,
    y2: 15.7912,
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 40.5352 14.001)",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.318132 0.948047 0.948047 0.318132 45.9668 16.0811)",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50.6011,
    y1: 15.8584,
    x2: 51.6292,
    y2: 18.9222,
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13141 11.022C8.39329 7.78607 12.0926 5.8584 16.0407 5.8584V5.8584C20.1771 5.8584 24.0264 7.97309 26.2449 11.4643L26.8574 12.4282L26.2449 13.3922C24.0264 16.8834 20.1771 18.998 16.0407 18.998V18.998C12.0926 18.998 8.39329 17.0704 6.13141 13.8345L5.14844 12.4282L6.13141 11.022Z",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2891 12.4282C12.2891 10.3774 13.9516 8.71484 16.0024 8.71484V8.71484C18.0533 8.71484 19.7158 10.3774 19.7158 12.4282V12.4282C19.7158 14.4791 18.0533 16.1416 16.0024 16.1416V16.1416C13.9516 16.1416 12.2891 14.4791 12.2891 12.4282V12.4282Z",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.65371,
    y1: 8.63853,
    x2: 6.36855,
    y2: 6.35337,
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 23.4316 8.14355)",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.318132 -0.948047 -0.948047 -0.318132 18 6.06348)",
    stroke: "#2565E7",
    strokeWidth: 1.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3657,
    y1: 6.28617,
    x2: 12.3376,
    y2: 3.22237,
    stroke: "#2565E7",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesIllustrationIcon);
export default __webpack_public_path__ + "static/media/eyes-illustration-icon.17f9205127ac4fa10a8a64109381de24.svg";
export { ForwardRef as ReactComponent };